'use strict';
'use client';
import { j as s } from "../../external/react/jsx-runtime.js";
import a from "../../external/classnames/index.js";
import e from "./two-column-section.module.scss.js";
const c = ({
  className: r,
  left: t,
  right: o
}) => /* @__PURE__ */ s.jsxs("section", { className: a(e.wrapper, r), children: [
  /* @__PURE__ */ s.jsx("div", { className: e.left, children: t }),
  /* @__PURE__ */ s.jsx("div", { className: e.right, children: o })
] });
export {
  c as default
};
